import React from 'react';
import type {BoxProps} from '@tempo/core';
import {Box, Flex} from '@tempo/core';

export type HeaderRowProps = {
	leftElements?: React.ReactNode;
	rightElements?: React.ReactNode;
	rightElementsProps?: BoxProps;
	border?: 'top' | 'bottom' | 'none';
	containerProps?: BoxProps;
} & BoxProps;

const HeaderRow = ({
	leftElements,
	rightElements,
	rightElementsProps,
	border = 'bottom',
	containerProps,
	...props
}: HeaderRowProps) => {
	return (
		<Box
			{...(border === 'top'
				? {
						borderTopStyle: 'solid',
						borderTopWidth: '1px',
					}
				: border === 'bottom'
					? {
							borderBottomStyle: 'solid',
							borderBottomWidth: '1px',
						}
					: {})}
			borderColor="divider.neutral.primary.default"
			{...props}
		>
			<Flex
				justifyContent="space-between"
				px={{base: 'spacing.m', sm: 'spacing.l', md: 'spacing.xl'}}
				py={{base: 'spacing.s', md: 'spacing.m'}}
				alignItems="center"
				overflow="visible"
				{...containerProps}
			>
				<Box flex={1} maxWidth="100%" minWidth={0}>
					<Flex
						flexFlow={'row wrap'}
						gap="spacing.s"
						alignItems="center"
						maxWidth="100%"
					>
						{leftElements}
					</Flex>
				</Box>

				<Box flexShrink={0}>
					<Flex
						flexFlow={'row wrap'}
						gap="spacing.s"
						alignItems="center"
						justifyContent="flex-end"
						{...rightElementsProps}
					>
						{rightElements}
					</Flex>
				</Box>
			</Flex>
		</Box>
	);
};

export default HeaderRow;
